import createClient, { type Middleware } from 'openapi-fetch';
import type { paths } from '@nrjx/api';

// Fonction utilitaire pour décoder un JWT
function decodeJwt(token: string) {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded);
  } catch {
    return null;
  }
}

export const useApiV2 = () => {
  const runtimeConfig = useRuntimeConfig();
  const store = firebaseStore();

  // Fonction pour obtenir un token valide (refresh si expiré)
  async function getValidToken() {
    let token = store.getAccessToken;
    if (!token) return null;
    const decoded = decodeJwt(token);

    const now = Math.floor(Date.now() / 1000);
    if (!decoded || decoded.exp < now) {
      const { $firebase } = useNuxtApp();
      token = (await $firebase.currentUser?.getIdToken(true)) ?? null;
      store.accessToken = token;
    }
    return token;
  }

  const authMiddleware: Middleware = {
    async onRequest({ request }) {
      const token = await getValidToken();
      if (token) {
        request.headers.set('Authorization', `Bearer ${token}`);
      }
      return request;
    },
  };

  const client = createClient<paths>({
    baseUrl: runtimeConfig.public.apiV2Url,
    headers: {},
  });

  client.use(authMiddleware);

  return {
    client,
  };
};
